import { useApp } from 'contexts/app';
import { useMemo } from 'react';
import { buildSessionContext, pruneEmptyContext } from 'utils/chat/instructorHugoContext';
import { getRouteChatKey } from './useInstructorHugoChatHelpers';

const useInstructorHugoContext = ({ auth, pathname, sessionContext }) => {
    const {
        assignments,
        course,
        currentAssignment,
        instructorHugoLiveContext,
        instructorHugoVisibleRows,
        instructorHugoPageView,
        rubrics,
    } = useApp();

    const derivedSessionContext = useMemo(() => buildSessionContext({ auth, pathname }), [auth, pathname]);
    const currentRouteChatKey = useMemo(
        () => getRouteChatKey({ auth, sessionContext: derivedSessionContext }),
        [auth, derivedSessionContext]
    );

    const threadContext = sessionContext;
    const currentRouteContext = derivedSessionContext;
    const { pageContext, routeContext } = currentRouteContext;
    const assignmentName =
        currentAssignment?.title ||
        currentAssignment?.name ||
        assignments?.find(({ id }) => id === routeContext.assignmentId)?.title ||
        assignments?.find(({ id }) => id === routeContext.assignmentId)?.name;
    const rubric = rubrics?.find(({ id }) => id === routeContext.detailId);
    const rubricName = rubric?.name || rubric?.title;
    const outgoingPageContext = useMemo(
        () =>
            pruneEmptyContext({
                ...pageContext,
                active_tab:
                    pageContext.page_type === instructorHugoPageView?.page_type
                        ? instructorHugoPageView.view
                        : pageContext.active_tab,
                selected_item_id: routeContext.detailId,
                visible_rows: instructorHugoVisibleRows,
                assignment_name: assignmentName,
                course_name: course?.name,
                rubric_name: rubricName,
            }),
        [
            assignmentName,
            course?.name,
            instructorHugoPageView,
            instructorHugoVisibleRows,
            pageContext,
            rubricName,
            routeContext.detailId,
        ]
    );

    return {
        currentRouteChatKey,
        derivedSessionContext,
        outgoingContext: instructorHugoLiveContext,
        outgoingPageContext,
        scope: threadContext.scope,
    };
};

export default useInstructorHugoContext;
